import { render, staticRenderFns } from "./AppBarAuthentication.vue?vue&type=template&id=c8f8580c&"
import script from "./AppBarAuthentication.vue?vue&type=script&lang=js&"
export * from "./AppBarAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8f8580c')) {
      api.createRecord('c8f8580c', component.options)
    } else {
      api.reload('c8f8580c', component.options)
    }
    module.hot.accept("./AppBarAuthentication.vue?vue&type=template&id=c8f8580c&", function () {
      api.rerender('c8f8580c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/AppBarAuthentication.vue"
export default component.exports